<template>
  <BModal
    id="send-mail-modal"
    ref="send-mail-modal"
    hide-footer="hide-footer"
    modal-class="modal-width-340"
  >
    <template slot="modal-title">
      {{ __('Enviar e-mail de teste') }}
    </template>
    <template slot="default">
      <form
        class="form"
        method="post"
      >
        <div class="form-group">
          <label>{{ __('Enviar para') }}</label>
          <input
            class="form-control"
            type="email"
            required=""
            v-model="email"
          >
        </div>
        <div class="modal-footer default-modal-footer">
          <button
            class="btn btn-box"
            type="submit"
            @click.prevent="send"
            :disabled="sending"
          >
            <span v-if="! sending">{{ __('Enviar') }}</span><span v-else><i class="fa fa-circle-o-notch fa-spin mr-1" /> {{ __('Enviando...') }}</span>
          </button>
        </div>
      </form>
    </template>
  </BModal>
</template>

<script>
import { BModal } from 'bootstrap-vue';

export default {
  components: {
    BModal,
  },

  props: ['user', 'id'],

  data () {
    return {
      email: '',
      sending: false,
    };
  },

  mounted () {
    Bus.$on('sendMailModal', () => {
      this.$nextTick(() => {
        this.$refs['send-mail-modal'].show();
      });
    });
  },

  methods: {
    send () {
      Alert.error(this.__('A funcionalidade de envio de e-mail de teste foi desabilitada'));

      this.$refs['send-mail-modal'].hide();
    },
  },
};
</script>
